"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedTypes = void 0;
class SupportedTypes {
    static all() {
        return [
            this.voiceInput,
            this.playMedia,
            this.multipleChoice,
            this.scoringResults,
            this.dialogue,
            this.tutorial,
            this.openAnswer,
            this.leadForm
        ];
    }
}
exports.SupportedTypes = SupportedTypes;
SupportedTypes.voiceInput = {
    id: "voice_input",
    name: "VoiceInput",
    visibleInMenu: true
};
SupportedTypes.playMedia = {
    id: "play_media",
    name: "PlayMedia",
    visibleInMenu: true
};
SupportedTypes.multipleChoice = {
    id: "multiple_choice",
    name: "MultipleChoice",
    visibleInMenu: true
};
SupportedTypes.dialogue = {
    id: "dialogue",
    name: "Dialogue",
    visibleInMenu: true
};
SupportedTypes.tutorial = {
    id: "tutorial",
    name: "Tutorial",
    visibleInMenu: true
};
SupportedTypes.openAnswer = {
    id: "open_answer",
    name: "Open Answer",
    visibleInMenu: true
};
SupportedTypes.scoringResults = {
    id: "results",
    name: "ScoringResults",
    visibleInMenu: false
};
SupportedTypes.leadForm = {
    id: "lead_form",
    name: "Lead Form",
    visibleInMenu: false
};
